/** @file Generic confirm dialog (returns boolean). */
import { h } from "./dom.js";
import { openModal } from "./modal.js";

/**
 * @param {{ title: string, body?: string, destructive?: boolean, confirmLabel?: string }} opts
 * @returns {Promise<boolean>}
 */
export function openConfirmDialog(opts) {
  const { title, body = "", destructive = false, confirmLabel = "OK" } = opts;
  return openModal((close) => {
    const confirm = h(
      "button",
      {
        type: "button",
        class: destructive
          ? "hb-btn min-h-11 hb-btn--danger"
          : "hb-btn hb-btn--primary min-h-11",
      },
      [confirmLabel],
    );
    const cancel = h("button", { type: "button", class: "hb-btn min-h-11" }, ["Abbrechen"]);
    cancel.addEventListener("click", () => close(false));
    confirm.addEventListener("click", () => close(true));
    return h("div", { class: "flex flex-col gap-3" }, [
      h("h2", { class: "text-xl font-bold" }, [title]),
      body ? h("p", { class: "text-sm text-neutral-300" }, [body]) : null,
      h("div", { class: "flex gap-2 justify-end mt-2" }, [cancel, confirm]),
    ]);
  }).then((r) => r === true);
}
